import { createFileRoute } from '@tanstack/react-router'

import { isSuccess, success } from '@orus.eu/result'
import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'
import { SearchDocumentationPageSkeleton } from '#/modules/documentation/back-office/search-documentation-page/search-documentation-page-skeleton.tsx'
import { SearchDocumentationPage } from '#/modules/documentation/back-office/search-documentation-page/search-documentation-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/documentation/search')({
  beforeLoad: ({ context }) =>
    requirePermissions(
      {
        session: {
          ...context.session,
          getSessionResult: async () => {
            const result = await context.session.getSessionResult()
            if (!isSuccess(result)) return result

            switch (result.output.permissions.type) {
              case 'client':
              case 'platform':
                return result
              case 'partner': {
                // Match the BO shell and former PermissionChecker: only the first membership is active.
                const membership = result.output.permissions.memberships.at(0)
                return success({
                  ...result.output,
                  allPermissions: membership?.rolesPermissions.flatMap(({ permissions }) => permissions) ?? [],
                })
              }
            }
          },
        },
      },
      [anyOfPermissions('search', 'search.allowedOnly')],
    ),
  pendingMs: 150,
  pendingComponent: () => (
    <PharaohNextScope surface="bo">
      <SearchDocumentationPageSkeleton />
    </PharaohNextScope>
  ),
  component: () => (
    <PharaohNextScope surface="bo">
      <SearchDocumentationPage />
    </PharaohNextScope>
  ),
})
